import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Util } from 'src/shared/util/util';

@Component({
  selector: 'app-gift-code-landing',
  template: `
    <tidy-wrapper>
      <tidy-card>
        <tidy-row [align]="'center'">
          <ion-spinner name="lines" />
        </tidy-row>
      </tidy-card>
    </tidy-wrapper>
  `,
  standalone: false
})
export class GiftCodeLandingPage implements OnInit {
  private route = inject(ActivatedRoute);
  private navCtrl = inject(CustomNavController);
  private util = inject(Util);

  ngOnInit() {
    const routeData = this.route.snapshot.data;
    const routeParams = this.route.snapshot.params;

    // Get code from route data (hardcoded routes) or URL param (referral pattern)
    const code = routeData['giftCode'] || routeParams['code'];

    if (code) {
      localStorage.setItem('appliedGiftCode', JSON.stringify({
        code,
        appliedAt: Date.now()
      }));
      this.util.showSuccess(`"${code.toUpperCase()}" code applied! It will be used at checkout.`, 5000);
    }

    this.navCtrl.navigateRoot('properties');
  }
}
